<template>

  <form method="post" id="interest_editor">
    <div v-if="is_edit" class="PageT" style="text-align:center;">
      <el-button @click="onFrom">保存</el-button>
    </div>
    <div class="PageM">
      <table width="100%" border="0" cellpadding="0" cellspacing="0" align="center">
        <tbody><tr>
          <td width="100%" align="center">
            <!-- begin -->
            <table cellspacing="0" width="100%" border="0">
              <!-- 题头 -->
              <tbody><tr>
                <td>
                  <table cellspacing="0" cellpadding="0" width="90%" align="center" border="0">
                    <!--
                    <tr>
                      <td align="center"><b><font id="ParentName" style="FONT-SIZE:15pt;POSITION:relative;TOP:3px"></font></b></td>
                    </tr>
                    <tr>
                      <td align="center" height="5"></td>
                    </tr>

                    <tr>
                      <td align="center" colspan="3"><b><font id="InvestItemName" style="FONT-SIZE:15pt;POSITION:relative;TOP:3px"></font></b></td>
                    </tr>
                    -->
                    <tbody><tr>
                      <td align="center" height="10" colspan="3"></td>
                    </tr>
                    <!--
                    <tr>
                      <td align="right" width="30%">
                        <font color="red">答题进度</font>
                      </td>
                      <td width="2%">
                      </td>
                      <td align="left" width="68%">
                        <script language="javascript">
                          txt += '<div id="PBouter"  style="position:relative; visibility:visible; width:'+barwidth+'px; height:'+barheight+'px;" class=BAR>';
                          txt += '<div style="position:absolute; top:1px; left:1px; width:'+(barwidth-3)+'px; height:'+(barheight-3)+'px; background-color:'+unloadedcolor+'; font-size:1px;"></div>';
                          txt += '<div id="PBdone" style="position:absolute; top:1px; left:1px; width:0px; height:'+(barheight-4)+'px; background-color:'+loadedcolor+'; font-size:1px;"></div>';
                          txt += '<label style="position:absolute; top:-1px; left:'+barwidth/2+'px; font-size:9pt;" id=dis>0%</label>';
                          txt += '</div>';
                          document.write(txt);
                        </script>
                      </td>
                    </tr>
                    -->
                    </tbody></table>
                </td>
              </tr>
              <tr>
                <td>
                  <table cellspacing="0" cellpadding="0" width="90%" align="center" border="0">
                    <tbody><tr><td style="margin-top:3px">
                      <table height="100%" cellspacing="0" cellpadding="0" width="100%" style="border:1px solid #B0C8E0">
                        <tbody><tr>
                          <td colspan="2" height="20" align="left" style="padding-left:2px;font-size:14px;background-color:#B0C8E0;border-top:1px solid #B0C8E0;"><b style="font-size:14px;">对该客户兴趣爱好的判断及描述</b> 本页面信息完整率:{{sore_val}}%</td></tr>
                        <tr><td colspan="2" style="padding:5px;border-top:1px dotted #B0C8E0;"><table cellspacing="0" cellpadding="0" width="100%" align="center" border="0">
                          <tbody><tr isgotta="0" questionkind="8" minanswercount="0" maxanswercount="100" id="tr_48"><td><font style="font-size:14px;">旅行</font> <br><br>

                            <input type="checkbox" id="xq_48_231_0" name="AnswersFor_48" v-model="form.xq_48_231_0"  style="border-width: 0px;"><label for="xq_48_231_0">&nbsp;自驾汽车旅行</label>
                            （工作日驾驶汽车<input type="text" class="UTB" id="xq_48_232_1" name="AnswersFor_48" maxlength="200" v-model="form.xq_48_232_1">&nbsp;
                            休息日驾驶汽车<input type="text" class="UTB" id="xq_48_233_1" name="AnswersFor_48" maxlength="200" v-model="form.xq_48_233_1">&nbsp;
                            配偶驾驶的汽车<input type="text" class="UTB" id="xq_48_234_1" name="AnswersFor_48" maxlength="200" v-model="form.xq_48_234_1">&nbsp;
                            子女驾驶的汽车<input type="text" class="UTB" id="xq_48_235_1" name="AnswersFor_48" maxlength="200" v-model="form.xq_48_235_1">&nbsp;
                            长辈驾驶的汽车<input type="text" class="UTB" id="xq_48_236_1" name="AnswersFor_48" maxlength="200" v-model="form.xq_48_236_1">&nbsp;
                            喜爱的轿车品牌<input type="text" class="UTB" id="xq_48_237_1" name="AnswersFor_48" maxlength="200" v-model="form.xq_48_237_1">&nbsp;
                            喜爱的跑车品牌<input type="text" class="UTB" id="xq_48_238_1" name="AnswersFor_48" maxlength="200" v-model="form.xq_48_238_1">&nbsp;
                            喜爱的SUV品牌 <input type="text" class="UTB" id="xq_48_239_1" name="AnswersFor_48" maxlength="200" v-model="form.xq_48_239_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <br>
                            <input type="checkbox" id="xq_48_240_0" name="AnswersFor_48"  style="border-width: 0px;" v-model="form.xq_48_240_0"><label for="xq_48_240_0">&nbsp;自助/商务旅行</label>
                            （喜爱的旅行目的地-国内<input type="text" class="UTB" id="xq_48_241_1" name="AnswersFor_48" maxlength="200" value="" v-model="form.xq_48_241_1">&nbsp;
                            喜爱的旅行目的地-国外<input type="text" class="UTB" id="xq_48_242_1" name="AnswersFor_48" maxlength="200" value="" v-model="form.xq_48_242_1">&nbsp;
                            喜爱的酒店品牌<input type="text" class="UTB" id="xq_48_243_1" name="AnswersFor_48" maxlength="200" value="" v-model="form.xq_48_243_1">&nbsp;
                            ）&nbsp;&nbsp;
                          </td></tr>
                          </tbody></table></td></tr>
                        <tr><td colspan="2" style="padding:5px;border-top:1px dotted #B0C8E0;"><table cellspacing="0" cellpadding="0" width="100%" align="center" border="0">
                          <tbody><tr isgotta="0" questionkind="5" minanswercount="0" maxanswercount="100" id="tr_49"><td><font style="font-size:14px;">研究金融投资业务</font> <br><br>

                            <input type="checkbox" id="xq_49_244_0" name="AnswersFor_49"  style="border-width: 0px;" v-model="form.xq_49_244_0"><label for="xq_49_244_0">&nbsp;股票</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_49_245_0" name="AnswersFor_49"  style="border-width: 0px;" v-model="form.xq_49_245_0"><label for="xq_49_245_0">&nbsp;期货</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_49_246_0" name="AnswersFor_49"  style="border-width: 0px;" v-model="form.xq_49_246_0"><label for="xq_49_246_0">&nbsp;基金</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_49_247_0" name="AnswersFor_49"  style="border-width: 0px;" v-model="form.xq_49_247_0"><label for="xq_49_247_0">&nbsp;债券</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_49_248_0" name="AnswersFor_49"  style="border-width: 0px;" v-model="form.xq_49_248_0"><label for="xq_49_248_0">&nbsp;理财型保险</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_49_249_0" name="AnswersFor_49"  style="border-width: 0px;" v-model="form.xq_49_249_0"><label for="xq_49_249_0">&nbsp;黄金</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_49_250_0" name="AnswersFor_49"  style="border-width: 0px;" v-model="form.xq_49_250_0"><label for="xq_49_250_0">&nbsp;其他</label>&nbsp;&nbsp;
                            <input type="text" class="UTB" id="xq_49_0_1" name="AnswersFor_49" maxlength="5000" value="" v-model="form.xq_49_0_1">&nbsp;&nbsp;
                          </td></tr>
                          </tbody></table></td></tr>
                        <tr><td colspan="2" style="padding:5px;border-top:1px dotted #B0C8E0;"><table cellspacing="0" cellpadding="0" width="100%" align="center" border="0">
                          <tbody><tr isgotta="0" questionkind="8" minanswercount="0" maxanswercount="100" id="tr_50"><td><font style="font-size:14px;">运动</font> <br><br>

                            <input type="checkbox" id="xq_50_251_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_251_0"><label for="xq_50_251_0">&nbsp;户外极限运动</label>
                            （<input type="checkbox" id="xq_50_252_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_252_0"><label for="xq_50_252_0">&nbsp;登山</label>&nbsp;
                            <input type="checkbox" id="xq_50_253_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_253_0"><label for="xq_50_253_0">&nbsp;滑翔</label>&nbsp;
                            <input type="checkbox" id="xq_50_254_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_254_0"><label for="xq_50_254_0">&nbsp;跳伞</label>&nbsp;
                            <input type="checkbox" id="xq_50_255_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_255_0"><label for="xq_50_255_0">&nbsp;驾驶飞机，喜爱的品牌</label>
                            <input type="text" class="UTB" id="xq_50_255_1" name="AnswersFor_50" maxlength="200" value="" v-model="form.xq_50_255_1">&nbsp;
                            <br>

                            <input type="checkbox" id="xq_50_256_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_256_0"><label for="xq_50_256_0">&nbsp;游艇出海，喜爱的品牌</label>
                            <input type="text" class="UTB" id="xq_50_256_1" name="AnswersFor_50" maxlength="200" value="" v-model="form.xq_50_256_1">&nbsp;
                            <input type="checkbox" id="xq_50_257_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_257_0"><label for="xq_50_257_0">&nbsp;冲浪，喜爱的器具品牌</label>
                            <input type="text" class="UTB" id="xq_50_257_1" name="AnswersFor_50" maxlength="200" value="" v-model="form.xq_50_257_1">&nbsp;
                            <br>

                            <input type="checkbox" id="xq_50_258_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_258_0"><label for="xq_50_258_0">&nbsp;自行车，喜爱的品牌</label>
                            <input type="text" class="UTB" id="xq_50_258_1" name="AnswersFor_50" maxlength="200" value="" v-model="form.xq_50_258_1">&nbsp;
                            <input type="checkbox" id="xq_50_259_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_259_0"><label for="xq_50_259_0">&nbsp;滑板，喜爱的器具品牌</label>
                            <input type="text" class="UTB" id="xq_50_259_1" name="AnswersFor_50" maxlength="200" value="" v-model="form.xq_50_259_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <br>
                            <input type="checkbox" id="xq_50_260_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_260_0"><label for="xq_50_260_0">&nbsp;汽车改装及越野</label>
                            （喜爱的越野车品牌<input type="text" class="UTB" id="xq_50_261_1" name="AnswersFor_50" maxlength="200" value="" v-model="form.xq_50_261_1">&nbsp;
                            喜爱的改装品牌<input type="text" class="UTB" id="xq_50_262_1" name="AnswersFor_50" maxlength="200" value="" v-model="form.xq_50_262_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <br>
                            <input type="checkbox" id="xq_50_263_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_263_0"><label for="xq_50_263_0">&nbsp;打高尔夫</label>
                            （喜爱的球场<input type="text" class="UTB" id="xq_50_264_1" name="AnswersFor_50" maxlength="200" value="" v-model="form.xq_50_264_1">&nbsp;
                            喜爱的球具品牌<input type="text" class="UTB" id="xq_50_265_1" name="AnswersFor_50" maxlength="200" value="" v-model="form.xq_50_265_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <br>
                            <input type="checkbox" id="xq_50_266_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_266_0"><label for="xq_50_266_0">&nbsp;马术</label>
                            （喜爱的马场<input type="text" class="UTB" id="xq_50_267_1" name="AnswersFor_50" maxlength="200" value="" v-model="form.xq_50_267_1">&nbsp;
                            喜爱的马具品牌<input type="text" class="UTB" id="xq_50_268_1" name="AnswersFor_50" maxlength="200" value="" v-model="form.xq_50_268_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <br>
                            <input type="checkbox" id="xq_50_269_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_269_0"><label for="xq_50_269_0">&nbsp;健身</label>
                            （常去的健身中心<input type="text" class="UTB" id="xq_50_270_1" name="AnswersFor_50" maxlength="200" value="" v-model="form.xq_50_270_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <input type="checkbox" id="xq_50_271_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_271_0"><label for="xq_50_271_0">&nbsp;打网球</label>
                            （常去的网球场<input type="text" class="UTB" id="xq_50_272_1" name="AnswersFor_50" maxlength="200" value="" v-model="form.xq_50_272_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <br>
                            <input type="checkbox" id="xq_50_273_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_273_0"><label for="xq_50_273_0">&nbsp;打羽毛球</label>
                            （常去的羽毛球场<input type="text" class="UTB" id="xq_50_274_1" name="AnswersFor_50" maxlength="200" value="" v-model="form.xq_50_274_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <input type="checkbox" id="xq_50_275_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_275_0"><label for="xq_50_275_0">&nbsp;瑜珈</label>
                            （常去的瑜珈馆<input type="text" class="UTB" id="xq_50_276_1" name="AnswersFor_50" maxlength="200" value="" v-model="form.xq_50_276_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <br>
                            <input type="checkbox" id="xq_50_277_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_277_0"><label for="xq_50_277_0">&nbsp;太极拳</label>
                            &nbsp;&nbsp;
                            <input type="checkbox" id="xq_50_278_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_278_0"><label for="xq_50_278_0">&nbsp;武术</label>
                            &nbsp;&nbsp;
                            <input type="checkbox" id="xq_50_279_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_279_0"><label for="xq_50_279_0">&nbsp;拳击</label>
                            &nbsp;&nbsp;
                            <input type="checkbox" id="xq_50_280_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_280_0"><label for="xq_50_280_0">&nbsp;跆拳道</label>
                            &nbsp;&nbsp;
                            <input type="checkbox" id="xq_50_281_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_281_0"><label for="xq_50_281_0">&nbsp;棋牌</label>
                            &nbsp;&nbsp;
                            <input type="checkbox" id="xq_50_282_0" name="AnswersFor_50"  style="border-width: 0px;" v-model="form.xq_50_282_0"><label for="xq_50_282_0">&nbsp;其他</label>
                            <input type="text" class="UTB" id="xq_50_282_1" name="AnswersFor_50" maxlength="5000" value="" v-model="form.xq_50_282_1">
                            &nbsp;&nbsp;
                          </td></tr>
                          </tbody></table></td></tr>
                        <tr><td colspan="2" style="padding:5px;border-top:1px dotted #B0C8E0;"><table cellspacing="0" cellpadding="0" width="100%" align="center" border="0">
                          <tbody><tr isgotta="0" questionkind="8" minanswercount="0" maxanswercount="100" id="tr_51"><td><font style="font-size:14px;">收藏</font> <br><br>

                            <input type="checkbox" id="xq_51_283_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_283_0"><label for="xq_51_283_0">&nbsp;收藏古董-喜爱的类型</label>
                            （<input type="checkbox" id="xq_51_284_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_284_0"><label for="xq_51_284_0">&nbsp;器皿</label>&nbsp;
                            <input type="checkbox" id="xq_51_285_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_285_0"><label for="xq_51_285_0">&nbsp;玉石</label>&nbsp;
                            <input type="checkbox" id="xq_51_286_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_286_0"><label for="xq_51_286_0">&nbsp;木制品</label>&nbsp;
                            <input type="checkbox" id="xq_51_287_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_287_0"><label for="xq_51_287_0">&nbsp;钱币</label>&nbsp;
                            <input type="checkbox" id="xq_51_288_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_288_0"><label for="xq_51_288_0">&nbsp;家具</label>&nbsp;
                            <input type="checkbox" id="xq_51_289_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_289_0"><label for="xq_51_289_0">&nbsp;其他</label>
                            <input type="text" class="UTB" id="xq_51_289_1" name="AnswersFor_51" maxlength="200" value="" v-model="form.xq_51_289_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <br>
                            <input type="checkbox" id="xq_51_290_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_290_0"><label for="xq_51_290_0">&nbsp;收藏字画-喜爱的类型</label>
                            （<input type="checkbox" id="xq_51_291_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_291_0"><label for="xq_51_291_0">&nbsp;中国画</label>&nbsp;
                            <input type="checkbox" id="xq_51_292_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_292_0"><label for="xq_51_292_0">&nbsp;油画</label>&nbsp;
                            <input type="checkbox" id="xq_51_293_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_293_0"><label for="xq_51_293_0">&nbsp;版画</label>&nbsp;
                            <input type="checkbox" id="xq_51_294_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_294_0"><label for="xq_51_294_0">&nbsp;书法</label>&nbsp;
                            <input type="checkbox" id="xq_51_295_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_295_0"><label for="xq_51_295_0">&nbsp;篆刻品</label>&nbsp;
                            <input type="checkbox" id="xq_51_296_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_296_0"><label for="xq_51_296_0">&nbsp;其他</label>
                            <input type="text" class="UTB" id="xq_51_296_1" name="AnswersFor_51" maxlength="200" value="" v-model="form.xq_51_296_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <br>
                            <input type="checkbox" id="xq_51_297_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_297_0"><label for="xq_51_297_0">&nbsp;收藏（其他）</label>
                            （<input type="checkbox" id="xq_51_298_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_298_0"><label for="xq_51_298_0">&nbsp;邮票</label>&nbsp;
                            <input type="checkbox" id="xq_51_299_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_299_0"><label for="xq_51_299_0">&nbsp;雕塑</label>&nbsp;
                            <input type="checkbox" id="xq_51_300_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_300_0"><label for="xq_51_300_0">&nbsp;装置艺术</label>&nbsp;
                            <input type="checkbox" id="xq_51_301_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_301_0"><label for="xq_51_301_0">&nbsp;票证</label>&nbsp;
                            <input type="checkbox" id="xq_51_302_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_302_0"><label for="xq_51_302_0">&nbsp;书籍</label>&nbsp;
                            <input type="checkbox" id="xq_51_303_0" name="AnswersFor_51"  style="border-width: 0px;" v-model="form.xq_51_303_0"><label for="xq_51_303_0">&nbsp;其他</label>
                            <input type="text" class="UTB" id="xq_51_303_1" name="AnswersFor_51" maxlength="200" value="" v-model="form.xq_51_303_1">&nbsp;
                            ）&nbsp;&nbsp;
                          </td></tr>
                          </tbody></table></td></tr>
                        <tr><td colspan="2" style="padding:5px;border-top:1px dotted #B0C8E0;"><table cellspacing="0" cellpadding="0" width="100%" align="center" border="0">
                          <tbody><tr isgotta="0" questionkind="8" minanswercount="0" maxanswercount="100" id="tr_52"><td><font style="font-size:14px;">美食美酒和茶艺</font> <br><br>

                            <input type="checkbox" id="xq_52_304_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_304_0"><label for="xq_52_304_0">&nbsp;茶艺-喜爱的类型</label>
                            （<input type="checkbox" id="xq_52_305_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_305_0"><label for="xq_52_305_0">&nbsp;普洱茶</label>&nbsp;
                            <input type="checkbox" id="xq_52_306_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_306_0"><label for="xq_52_306_0">&nbsp;乌龙茶</label>&nbsp;
                            <input type="checkbox" id="xq_52_307_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_307_0"><label for="xq_52_307_0">&nbsp;绿茶</label>&nbsp;
                            <input type="checkbox" id="xq_52_308_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_308_0"><label for="xq_52_308_0">&nbsp;花草茶</label>&nbsp;
                            <input type="checkbox" id="xq_52_309_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_309_0"><label for="xq_52_309_0">&nbsp;其他</label>
                            <input type="text" class="UTB" id="xq_52_309_1" name="AnswersFor_52" maxlength="200" value="" v-model="form.xq_52_309_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <br>
                            <input type="checkbox" id="xq_52_310_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_310_0"><label for="xq_52_310_0">&nbsp;茶艺-喜爱的茶具</label>
                            （<input type="checkbox" id="xq_52_311_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_311_0"><label for="xq_52_311_0">&nbsp;紫砂壶</label>&nbsp;
                            <input type="checkbox" id="xq_52_312_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_312_0"><label for="xq_52_312_0">&nbsp;瓷制品</label>&nbsp;
                            <input type="checkbox" id="xq_52_313_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_313_0"><label for="xq_52_313_0">&nbsp;琉璃制品</label>&nbsp;
                            <input type="checkbox" id="xq_52_314_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_314_0"><label for="xq_52_314_0">&nbsp;银器</label>&nbsp;
                            <input type="checkbox" id="xq_52_315_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_315_0"><label for="xq_52_315_0">&nbsp;其他</label>
                            <input type="text" class="UTB" id="xq_52_315_1" name="AnswersFor_52" maxlength="200" value="" v-model="form.xq_52_315_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <br>
                            <input type="checkbox" id="xq_52_316_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_316_0"><label for="xq_52_316_0">&nbsp;美酒-喜爱的类型</label>
                            （<input type="checkbox" id="xq_52_317_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_317_0"><label for="xq_52_317_0">&nbsp;红葡萄酒，喜爱的品牌</label>
                            <input type="text" class="UTB" id="xq_52_317_1" name="AnswersFor_52" maxlength="200" value="" v-model="form.xq_52_317_1">&nbsp;
                            <input type="checkbox" id="xq_52_318_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_318_0"><label for="xq_52_318_0">&nbsp;白葡萄酒，喜爱的品牌</label>
                            <input type="text" class="UTB" id="xq_52_318_1" name="AnswersFor_52" maxlength="200" value="" v-model="form.xq_52_318_1">&nbsp;
                            <input type="checkbox" id="xq_52_319_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_319_0"><label for="xq_52_319_0">&nbsp;白兰地，喜爱的品牌</label>
                            <input type="text" class="UTB" id="xq_52_319_1" name="AnswersFor_52" maxlength="200" value="" v-model="form.xq_52_319_1">&nbsp;
                            <input type="checkbox" id="xq_52_320_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_320_0"><label for="xq_52_320_0">&nbsp;威士忌，喜爱的品牌</label>
                            <input type="text" class="UTB" id="xq_52_320_1" name="AnswersFor_52" maxlength="200" value="" v-model="form.xq_52_320_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <br>
                            <input type="checkbox" id="xq_52_321_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_321_0"><label for="xq_52_321_0">&nbsp;雪茄</label>
                            （喜爱的品牌<input type="text" class="UTB" id="xq_52_322_1" name="AnswersFor_52" maxlength="200" value="" v-model="form.xq_52_322_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <input type="checkbox" id="xq_52_323_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_323_0"><label for="xq_52_323_0">&nbsp;美食</label>
                            （品种<input type="text" class="UTB" id="xq_52_818_1" name="AnswersFor_52" maxlength="200" value="" v-model="form.xq_52_818_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <br>
                            <input type="checkbox" id="xq_52_324_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_324_0"><label for="xq_52_324_0">&nbsp;厨艺-种类</label>
                            （<input type="checkbox" id="xq_52_325_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_325_0"><label for="xq_52_325_0">&nbsp;烘培</label>&nbsp;
                            <input type="checkbox" id="xq_52_326_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_326_0"><label for="xq_52_326_0">&nbsp;煲汤</label>&nbsp;
                            <input type="checkbox" id="xq_52_327_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_327_0"><label for="xq_52_327_0">&nbsp;中餐</label>&nbsp;
                            <input type="checkbox" id="xq_52_328_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_328_0"><label for="xq_52_328_0">&nbsp;西餐</label>&nbsp;
                            <input type="checkbox" id="xq_52_329_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_329_0"><label for="xq_52_329_0">&nbsp;其他</label>
                            <input type="text" class="UTB" id="xq_52_329_1" name="AnswersFor_52" maxlength="200" value="" v-model="form.xq_52_329_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <br>
                            <input type="checkbox" id="xq_52_330_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_330_0"><label for="xq_52_330_0">&nbsp;婴幼儿营养学</label>
                            &nbsp;&nbsp;
                            <input type="checkbox" id="xq_52_331_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_331_0"><label for="xq_52_331_0">&nbsp;老年营养学</label>
                            &nbsp;&nbsp;
                            <input type="checkbox" id="xq_52_332_0" name="AnswersFor_52"  style="border-width: 0px;" v-model="form.xq_52_332_0"><label for="xq_52_332_0">&nbsp;体育营养学</label>
                            &nbsp;&nbsp;
                          </td></tr>
                          </tbody></table></td></tr>
                        <tr><td colspan="2" style="padding:5px;border-top:1px dotted #B0C8E0;"><table cellspacing="0" cellpadding="0" width="100%" align="center" border="0">
                          <tbody><tr isgotta="0" questionkind="2" minanswercount="0" maxanswercount="100" id="tr_53" selectedvalues=""><td><font style="font-size:14px;">艺术类</font> <br><br>

                            <input type="checkbox" id="xq_53_333_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_333_0"><label for="xq_53_333_0">&nbsp;阅读</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_334_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_334_0"><label for="xq_53_334_0">&nbsp;写作</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_335_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_335_0"><label for="xq_53_335_0">&nbsp;电影</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_336_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_336_0"><label for="xq_53_336_0">&nbsp;音乐</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_337_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_337_0"><label for="xq_53_337_0">&nbsp;国际标准舞</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_338_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_338_0"><label for="xq_53_338_0">&nbsp;拉丁舞</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_339_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_339_0"><label for="xq_53_339_0">&nbsp;街舞</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_340_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_340_0"><label for="xq_53_340_0">&nbsp;中国民族舞</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_341_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_341_0"><label for="xq_53_341_0">&nbsp;美声唱法声乐</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_342_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_342_0"><label for="xq_53_342_0">&nbsp;民族唱法声乐</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_343_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_343_0"><label for="xq_53_343_0">&nbsp;通俗唱法声乐</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_344_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_344_0"><label for="xq_53_344_0">&nbsp;戏曲</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_345_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_345_0"><label for="xq_53_345_0">&nbsp;摄影</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_346_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_346_0"><label for="xq_53_346_0">&nbsp;油画</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_347_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_347_0"><label for="xq_53_347_0">&nbsp;国画</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_348_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_348_0"><label for="xq_53_348_0">&nbsp;书法</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_349_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_349_0"><label for="xq_53_349_0">&nbsp;刺绣</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_350_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_350_0"><label for="xq_53_350_0">&nbsp;编织</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_351_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_351_0"><label for="xq_53_351_0">&nbsp;服装设计</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_352_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_352_0"><label for="xq_53_352_0">&nbsp;服装制作</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_353_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_353_0"><label for="xq_53_353_0">&nbsp;家居品设计和制作</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_354_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_354_0"><label for="xq_53_354_0">&nbsp;室内装修设计</label>&nbsp;&nbsp;
                            <input type="checkbox" id="xq_53_355_0" name="AnswersFor_53"  style="border-width: 0px;" v-model="form.xq_53_355_0"><label for="xq_53_355_0">&nbsp;园艺</label>&nbsp;&nbsp;
                          </td></tr>
                          </tbody></table></td></tr>
                        <tr><td colspan="2" style="padding:5px;border-top:1px dotted #B0C8E0;"><table cellspacing="0" cellpadding="0" width="100%" align="center" border="0">
                          <tbody><tr isgotta="0" questionkind="8" minanswercount="0" maxanswercount="100" id="tr_54"><td><font style="font-size:14px;">其他</font> <br><br>

                            <input type="checkbox" id="xq_54_356_0" name="AnswersFor_54"  style="border-width: 0px;" v-model="form.xq_54_356_0"><label for="xq_54_356_0">&nbsp;SPA</label>
                            （喜爱的品牌<input type="text" class="UTB" id="xq_54_357_1" name="AnswersFor_54" maxlength="200" value="" v-model="form.xq_54_357_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <br>
                            <input type="checkbox" id="xq_54_358_0" name="AnswersFor_54"  style="border-width: 0px;" v-model="form.xq_54_358_0"><label for="xq_54_358_0">&nbsp;中医</label>
                            （<input type="checkbox" id="xq_54_359_0" name="AnswersFor_54"  style="border-width: 0px;" v-model="form.xq_54_359_0"><label for="xq_54_359_0">&nbsp;药理</label>&nbsp;
                            <input type="checkbox" id="xq_54_360_0" name="AnswersFor_54"  style="border-width: 0px;" v-model="form.xq_54_360_0"><label for="xq_54_360_0">&nbsp;理疗</label>&nbsp;
                            <input type="checkbox" id="xq_54_361_0" name="AnswersFor_54"  style="border-width: 0px;" v-model="form.xq_54_361_0"><label for="xq_54_361_0">&nbsp;其他</label>
                            <input type="text" class="UTB" id="xq_54_361_1" name="AnswersFor_54" maxlength="200" value="" v-model="form.xq_54_361_1">&nbsp;
                            ）&nbsp;&nbsp;
                            <br>
                            <input type="checkbox" id="xq_54_362_0" name="AnswersFor_54"  style="border-width: 0px;" v-model="form.xq_54_362_0"><label for="xq_54_362_0">&nbsp;其他</label>
                            <input type="text" class="UTB" id="xq_54_362_1" name="AnswersFor_54" maxlength="5000" value="" v-model="form.xq_54_362_1">
                            &nbsp;&nbsp;
                          </td></tr>
                          </tbody></table></td></tr>
                        </tbody></table>
                    </td></tr>
                    <tr><td height="10">&nbsp;</td></tr>

                    </tbody></table>
                </td>
              </tr>
              <!-- 题尾 -->
              <tr>
                <td>
                  <div class="PageT" style="text-align:center;">
                    <el-button @click="onFrom">保存</el-button>
                  </div>
                </td>
              </tr>
              </tbody></table>
            <!-- end -->
          </td>
        </tr>
        <!--
        <tr>
          <td colspan="3">
            <img src="../../../images/InvestManagement/bottom.gif" width="750" height="63" alt=""></td>
        </tr>
        -->
        </tbody></table>
      <div class="BottomLine"></div>
      <div class="BottomHr"></div>
    </div>
  </form>

</template>

<script>
export default {
  name: "interest-editor",
  props:{
    id:{
      type:Number,
      default(){
        return 0
      }
    },
    is_edit:{
      type: Boolean,
      default() {
        return true
      }
    }
  },
  data(){
    return{
      oldForm:{
        xq_48_231_0: false,
        xq_48_232_1: '',
        xq_48_233_1: '',
        xq_48_234_1: '',
        xq_48_235_1: '',
        xq_48_236_1: '',
        xq_48_237_1: '',
        xq_48_238_1: '',
        xq_48_239_1: '',
        xq_48_240_0: false,
        xq_48_241_1: '',
        xq_48_242_1: '',
        xq_48_243_1: '',
        xq_49_244_0: false,
        xq_49_245_0: false,
        xq_49_246_0: false,
        xq_49_247_0: false,
        xq_49_248_0: false,
        xq_49_249_0: false,
        xq_49_250_0: false,
        xq_49_0_1: '',
        xq_50_251_0: false,
        xq_50_252_0: false,
        xq_50_253_0: false,
        xq_50_254_0: false,
        xq_50_255_0: false,
        xq_50_255_1: '',
        xq_50_256_0: false,
        xq_50_256_1: '',
        xq_50_257_0: false,
        xq_50_257_1: '',
        xq_50_258_0: false,
        xq_50_258_1: '',
        xq_50_259_0: false,
        xq_50_259_1: '',
        xq_50_260_0: false,
        xq_50_261_1: '',
        xq_50_262_1: '',
        xq_50_263_0: false,
        xq_50_264_1: '',
        xq_50_265_1: '',
        xq_50_266_0: false,
        xq_50_267_1: '',
        xq_50_268_1: '',
        xq_50_269_0: false,
        xq_50_270_1: '',
        xq_50_271_0: false,
        xq_50_272_1: '',
        xq_50_273_0: false,
        xq_50_274_1: '',
        xq_50_275_0: false,
        xq_50_276_1: '',
        xq_50_277_0: false,
        xq_50_278_0: false,
        xq_50_279_0: false,
        xq_50_280_0: false,
        xq_50_281_0: false,
        xq_50_282_0: false,
        xq_50_282_1: '',
        xq_51_283_0: false,
        xq_51_284_0: false,
        xq_51_285_0: false,
        xq_51_286_0: false,
        xq_51_287_0: false,
        xq_51_288_0: false,
        xq_51_289_0: false,
        xq_51_289_1: '',
        xq_51_290_0: false,
        xq_51_291_0: false,
        xq_51_292_0: false,
        xq_51_293_0: false,
        xq_51_294_0: false,
        xq_51_295_0: false,
        xq_51_296_0: false,
        xq_51_296_1: '',
        xq_51_297_0: false,
        xq_51_298_0: false,
        xq_51_299_0: false,
        xq_51_300_0: false,
        xq_51_301_0: false,
        xq_51_302_0: false,
        xq_51_303_0: false,
        xq_51_303_1: '',
        xq_52_304_0: false,
        xq_52_305_0: false,
        xq_52_306_0: false,
        xq_52_307_0: false,
        xq_52_308_0: false,
        xq_52_309_0: false,
        xq_52_309_1: '',
        xq_52_310_0: false,
        xq_52_311_0: false,
        xq_52_312_0: false,
        xq_52_313_0: false,
        xq_52_314_0: false,
        xq_52_315_0: false,
        xq_52_315_1: '',
        xq_52_316_0: false,
        xq_52_317_0: false,
        xq_52_317_1: '',
        xq_52_318_0: false,
        xq_52_318_1: '',
        xq_52_319_0: false,
        xq_52_319_1: '',
        xq_52_320_0: false,
        xq_52_320_1: '',
        xq_52_321_0: false,
        xq_52_322_1: '',
        xq_52_323_0: false,
        xq_52_818_1: '',
        xq_52_324_0: false,
        xq_52_325_0: false,
        xq_52_326_0: false,
        xq_52_327_0: false,
        xq_52_328_0: false,
        xq_52_329_0: false,
        xq_52_329_1: '',
        xq_52_330_0: false,
        xq_52_331_0: false,
        xq_52_332_0: false,
        xq_53_333_0: false,
        xq_53_334_0: false,
        xq_53_335_0: false,
        xq_53_336_0: false,
        xq_53_337_0: false,
        xq_53_338_0: false,
        xq_53_339_0: false,
        xq_53_340_0: false,
        xq_53_341_0: false,
        xq_53_342_0: false,
        xq_53_343_0: false,
        xq_53_344_0: false,
        xq_53_345_0: false,
        xq_53_346_0: false,
        xq_53_347_0: false,
        xq_53_348_0: false,
        xq_53_349_0: false,
        xq_53_350_0: false,
        xq_53_351_0: false,
        xq_53_352_0: false,
        xq_53_353_0: false,
        xq_53_354_0: false,
        xq_53_355_0: false,
        xq_54_356_0: false,
        xq_54_357_1: '',
        xq_54_358_0: false,
        xq_54_359_0: false,
        xq_54_360_0: false,
        xq_54_361_0: false,
        xq_54_361_1: '',
        xq_54_362_0: false,
        xq_54_362_1: '',
      },
      form:{},
      sore_val:0
    }
  },
  created() {
    this.form=JSON.parse(JSON.stringify(this.oldForm));
  },
  mounted() {
    this.getData();
  },
  methods:{
    getData(){
      var that=this;
      ERP.getRequest({url:"admin/CustomerManagement/getCustomerInterest",data:{customer_id:this.id}},ret=>{
        if(ret.code&&ret.data){
          that.form=ret.data.content;
        }
      })
    },
    onFrom(){
      var that=this;
      ERP.postRequest({
        url:"admin/CustomerManagement/setCustomerInterest",
        data:{
          customer_id:that.id,
          content:that.form,
        }
      },ret=>{
        if(ret.code){
          this.$message.success(ret.msg)
        }else {
          this.$message.error(ret.msg||'提交失败')
        }
      })
    },
    getSore(old,now){
      let objKeys=Object.keys(old);
      let num=0;
      objKeys.map(ret=>{
        if(old[ret]!==now[ret]){
          num++;
        }
      })
      return num/objKeys.length;
    }
  },
  watch:{
    form:{
      handler(n){
        this.sore_val=Math.round(this.getSore(this.oldForm,n)*100*100)/100;
      },
      deep:true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./interest-editor/cs1.scss";
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/interest-editor.vue